<template>
  <div>
    <el-dialog
      :visible.sync="patentNumVisible"
      width="60%"
      :z-index="1000"
      :before-close="patentNumHandleClose"
    >
      <div class="flex-column dialog-visible text-left">
        <div class="option-list" style="margin-bottom: 20px">
          <el-radio-group
            v-model="filterCriteriaValue"
            @change="handleFilterChange"
          >
            <el-radio-button
              v-for="item in filterCriteriaOption"
              :key="item"
              :label="item"
              >{{ item }}</el-radio-button
            >
          </el-radio-group>
        </div>
        <div v-loading="achievementLoading">
          <div
            class="text-left item-bottom"
            v-for="(item, index) in achievementData"
            :key="index"
          >
            <achievement-item
              :ach-type="filterCriteriaValue"
              :ach-data="item"
            />
          </div>
          <div
            class="page-container"
            v-if="achievementData && achievementData.length"
            style="display: flex; justify-content: center; margin-top: 20px"
          >
            <el-pagination
              background
              @current-change="handleCurrentChange"
              :current-page="achievementParams.pageNum + 1"
              layout="prev, pager, next"
              :total="total"
            />
          </div>
          <el-empty v-else />
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getCoPaperListApi, getCoPatentListApi } from '@/api/details';
import AchievementItem from '@/views/details/comps/achievementItem.vue';

export default {
  name: 'achievementDialog',
  components: { AchievementItem },
  props: ['scholarId', 'orScholarId'],
  data() {
    return {
      patentNumVisible: false,
      achievementLoading: false,
      total: 0,
      achievementData: [],
      achievementParams: {
        centerScholarId: this.scholarId,
        coScholarId: this.orScholarId,
        pageNum: 0,
        pageSize: 10,
      },
      filterCriteriaOption: ['论文', '专利'],
      filterCriteriaValue: '论文',
    };
  },
  watch: {
    orScholarId: {
      handler() {
        this.achievementParams.coScholarId = this.orScholarId;
      },
    },
  },
  created() {},
  methods: {
    showDialog() {
      this.patentNumVisible = true;
      this.getPaperData();
      this.getPatentData();
    },
    patentNumHandleClose() {
      this.patentNumVisible = false;
    },
    handleFilterChange() {
      // 切换数据置空，页面置0
      this.achievementParams.pageNum = 0;
      this.achievementData = [];
      // 根据切换后的值调用对应的接口
      this.getAchievementData();
    },
    getPaperData() {
      getCoPaperListApi(this.achievementParams).then((res) => {
        if (res.data.totalCount === 0) {
          this.filterCriteriaOption = ['专利'];
          this.filterCriteriaValue = '专利';
          return;
        }
        this.achievementLoading = false;
        if (res.code === 200) {
          this.achievementData = res.data.data;
          this.total = res.data.totalCount;
        }
      });
    },
    getPatentData() {
      getCoPatentListApi(this.achievementParams).then((res) => {
        if (res.data.data.totalElements === 0) {
          this.filterCriteriaOption = ['论文'];
          return;
        }
        this.achievementLoading = false;
        if (res.code === 200) {
          this.achievementData = res.data.data.content;
          this.total = res.data.data.totalElements;
        }
      });
    },
    getAchievementData() {
      this.achievementLoading = true;
      if (this.filterCriteriaValue === '论文') {
        this.getPaperData();
      } else if (this.filterCriteriaValue === '专利') {
        this.getPatentData();
      }
    },
    handleCurrentChange(current) {
      this.achievementParams.pageNum = current - 1;
      this.getAchievementData();
    },
    /**
     * 跳转至详情页面
     */
    goDetails(path, id) {
      this.$router.push({ path: path, query: { id: id } });
    },
  },
};
</script>

<style scoped>
/deep/ .el-radio-group {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-left: 10px;
  margin-top: 15px;

  /deep/ .el-radio-button__inner {
    font-size: 16px !important;
    font-weight: 400;
    padding: 10px 20px !important;
    border-radius: 4px !important;
    border: none !important;
    margin-right: 20px;
    box-shadow: none !important;
    color: #666 !important;
    background-color: #eeeeee !important;
  }

  /deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    color: #ffffff !important;
    background: #2e1f88 !important;
  }
}
/deep/ .el-dialog__body {
  padding: 0 20px 30px;
}
.item-bottom {
  border-bottom: 1px solid #eeeeee;
  padding-bottom: 12px;
  margin-bottom: 15px;
}
</style>
